import { useI18n } from "../../../../hooks/i18n-hooks";
import ScreenCard from "../../../ScreenCard";
import { Linking, Platform, Pressable, StyleSheet } from "react-native";
import * as Notifications from "expo-notifications";
import { useCallback, useMemo } from "react";
import { WelcomeScreenProps } from "../Welcome";
import { useTheme } from "../../../../hooks/use-theme";
import * as Device from "expo-device";
import { useStatusBarTranslucent } from "../../../../hooks/use-status-bar-translucent";
import { WelcomeCarousel } from "../../../../components/WelcomeCarousel";
import Text from "../../../../components/Text";

export const SmallLayout = ({ navigation }: WelcomeScreenProps) => {
    const i18n = useI18n();
    const styles = useStyles();
    useStatusBarTranslucent();

    const goToPhoneNumberOrAskNotifications = useCallback(async () => {
        if (Platform.OS === "ios") {
            await Notifications.requestPermissionsAsync({
                ios: {
                    allowProvisional: true,
                },
            });
        }

        navigation.replace("SignupSigninStack");
    }, [navigation]);

    const goToSignup = useCallback(() => {
        navigation.replace("SignupSigninStack", { isSignup: true });
    }, [navigation]);

    const toAppStore = useCallback(async () => {
        if (Device.osName === "Android") {
            await Linking.openURL(
                "https://play.google.com/store/apps/details?id=ch.liftapp.app_production",
            );
        } else if (Device.osName === "iOS") {
            await Linking.openURL(
                "https://apps.apple.com/ch/app/lift-partenaire-professionnel/id6471666424",
            );
        }
    }, []);

    return (
        <ScreenCard
            isContentContainerFlex
            contentStyle={{ paddingBottom: 0, overflow: "visible" }}
            scrollEnabled={false}
            showsVerticalScrollIndicator={false}
            noBottomBlur
            buttons={[
                {
                    title: i18n.t("screens.auth.welcome.signup"),
                    onPress: goToSignup,
                    mode: "secondary",
                },
                {
                    title: i18n.t("screens.auth.welcome.login"),
                    onPress: goToPhoneNumberOrAskNotifications,
                    mode: "large-link",
                    textSize: "large",
                    size: "medium",
                    style: { backgroundColor: "transparent", borderWidth: 0 },
                },
            ]}
        >
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {(screenActionsHeight) => (
                <>
                    {Platform.OS === "web" && (
                        <Pressable style={styles.appBanner} onPress={() => void toAppStore()}>
                            <Text style={styles.bannerText}>
                                {i18n.t("screens.auth.welcome.download_app")}
                            </Text>
                        </Pressable>
                    )}
                    <WelcomeCarousel scrollViewBottomPadding={screenActionsHeight} />
                </>
            )}
        </ScreenCard>
    );
};

const useStyles = () => {
    const { colors, fonts } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                appBanner: {
                    backgroundColor: colors.onPrimary,
                    width: "100%",
                    height: 39,
                    alignItems: "center",
                    justifyContent: "center",
                },
                bannerText: {
                    ...fonts.bodyMedium,
                    fontSize: 13,
                    color: colors.secondary,
                },
            }),
        [colors.onPrimary, colors.secondary, fonts.bodyMedium],
    );
};
